import { useState, useEffect } from 'react';
import { healthApi } from '@/services/api';

interface HealthStatus {
  isHealthy: boolean;
  isChecking: boolean;
  lastChecked: Date | null;
  error: string | null;
}

export const useHealthCheck = (intervalMs: number = 30000) => {
  const [status, setStatus] = useState<HealthStatus>({
    isHealthy: false,
    isChecking: true,
    lastChecked: null,
    error: null,
  });

  const checkHealth = async () => {
    try {
      setStatus(prev => ({ ...prev, isChecking: true, error: null }));
      await healthApi.check();
      setStatus({
        isHealthy: true,
        isChecking: false,
        lastChecked: new Date(),
        error: null,
      });
    } catch (error) {
      setStatus({
        isHealthy: false,
        isChecking: false,
        lastChecked: new Date(),
        error: error instanceof Error ? error.message : '健康检查失败',
      });
    }
  };

  useEffect(() => {
    // 立即执行一次检查
    checkHealth();

    // 设置定期检查
    const interval = setInterval(checkHealth, intervalMs);

    return () => clearInterval(interval);
  }, [intervalMs]);

  return { ...status, checkHealth };
};